import React from "react";
import { primaryColor } from "../../../utility/constants/colorManager";
import { PENDING } from "../../../utility/constants/valueConstants";
import RejectReasonModal from "./RejectReasonModal";

function AlertModals({
  onClickCancel,
  onClickOk,
  loading,
  action = "Deactivate",
  reason = "Deactivating",
  role = "Client",
  data,
  isConditional = true,
  confirmButtonTitle = "",
  title = false,
}) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
      }}
    >
      {isConditional ? (
        data.activeStatus === PENDING ? (
          <p>Request is already in pending state</p>
        ) : (
          <RejectReasonModal
            title={title ? "" : `Do you want to ${action} this ${role}?`}
            onClickOK={onClickOk}
            onClickBack={onClickCancel}
            reason={reason}
            buttonColor2={primaryColor}
            loading={loading}
            button2={confirmButtonTitle}
          />
        )
      ) : (
        <RejectReasonModal
          title={title ? "" : `Do you want to ${action} this ${role}?`}
          onClickOK={onClickOk}
          onClickBack={onClickCancel}
          reason={reason}
          buttonColor2={primaryColor}
          loading={loading}
          button2={confirmButtonTitle}
        />
      )}
    </div>
  );
}

export default AlertModals;
